import ApiService from '@/services/ApiService';

class LocationsService {
  static async getLocationsQuickSearch(queryOrParams) {
    const { query, context } =
      typeof queryOrParams === 'string'
        ? { query: queryOrParams }
        : queryOrParams;
    const params = new URLSearchParams({ q: query });
    // The backend docstring claims `context: 'filter'`, but it actually checks
    // `context=true` as a string — without it, the search is Divisions-only
    // and never matches States.
    if (context) params.append('context', 'true');

    const composedURL = `/api3/locations/locations_quicksearch?${params.toString()}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getLocationsObjList(data) {
    const composedURL = `/api3/locations/locations_get_obj_list?data=${encodeURIComponent(
      JSON.stringify(data)
    )}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getLocationsStates({
    companyCountry = true,
    countryId,
    countryIsoCode,
  } = {}) {
    const params = new URLSearchParams();
    if (countryId) {
      params.append('country_id', countryId);
    } else if (countryIsoCode) {
      params.append('country_iso_code', countryIsoCode);
    } else {
      params.append('company_country', companyCountry);
    }

    const composedURL = `/api3/locations/states?${params.toString()}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async searchLocationDivisions(pattern) {
    const composedURL = `/api3/locations/divisions?pattern=${encodeURIComponent(
      pattern
    )}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getDivisionChildren({ stateId, parentDivisionId } = {}) {
    const params = new URLSearchParams();
    if (stateId) params.append('state_id', stateId);
    if (parentDivisionId) params.append('parent_division_id', parentDivisionId);

    const composedURL = `/api3/locations/divisions/children?${params.toString()}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getDivisionAncestors(divisionId) {
    const composedURL = `/api3/locations/divisions/${divisionId}/ancestors`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async searchExternalAddress({ address, countryIsoCode } = {}) {
    const params = new URLSearchParams();
    params.append('address', address);
    if (countryIsoCode) params.append('country', countryIsoCode);

    const composedURL = `/api3/locations/external_address_search?${params.toString()}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getCommercialDistrict({ divisionId, zipCode } = {}) {
    const params = new URLSearchParams();
    if (divisionId != null) params.append('division_id', divisionId);
    if (zipCode) params.append('zip_code', zipCode);

    const composedURL = `/api3/locations/commercial-districts/?${params.toString()}`;
    return ApiService.get(composedURL, undefined, true);
  }

  static async createCommercialDistrict(payload) {
    return ApiService.post(
      '/api3/locations/commercial-districts/',
      payload,
      undefined,
      false,
      true
    );
  }

  static async patchCommercialDistrict(payload) {
    return ApiService.patch(
      '/api3/locations/commercial-districts/',
      payload,
      undefined,
      true
    );
  }

  static async deleteCommercialDistrict(divisionId) {
    const composedURL = `/api3/locations/commercial-districts/?division_id=${encodeURIComponent(
      divisionId
    )}`;
    return ApiService.delete(composedURL, null, undefined, true);
  }
}

export default LocationsService;
